<template>
    <div
        :id="elementId"
        class="g-recaptcha"
        :data-sitekey="sitekey"
    ></div>
</template>
  
<script>
export default {
    name: 'grecaptcha',
    props: {
        sitekey: {
            type: String,
            required: true
        },
        elementId: {
            type: String,
            required: true
        },
    },
    data () {
        return {
            gAssignedId: null,
            captchaReady: false,
            checkInterval: null,
            checkIntervalRunCount: 0
        }
    },
    methods: {
        execute () {
            window.grecaptcha.execute(this.gAssignedId)
        },
        reset () {
            window.grecaptcha.reset(this.gAssignedId)
        },
        callback (recaptchaToken) {
            this.$emit('grecaptcha-callback', recaptchaToken)
            this.reset()
        },
        render () {
            this.gAssignedId = window.grecaptcha.render(this.elementId, {
                sitekey: this.sitekey,
                size: 'invisible',
                'callback': (recaptchaToken) => {
                    this.callback(recaptchaToken)
                },
                'expired-callback': () => {
                    this.reset()
                }
            })
        },
        loadAPIScript() {
            return new Promise((resolve, reject) => {
                const script = document.createElement('script');
                script.src = 'https://www.recaptcha.net/recaptcha/api.js?render=explicit';
                script.async = true;
                script.defer = true;
                script.onload = resolve;
                script.onerror = reject;
                document.head.appendChild(script);
            });
        },
        init() {
            this.loadAPIScript()
            .then(() => {
              this.checkInterval = setInterval(() => {
                  this.checkIntervalRunCount++
                  if (window.grecaptcha && window.grecaptcha.hasOwnProperty('render')){
                      this.captchaReady = true
                      this.$emit('grecaptcha-ready')
                  }
              }, 1000)
            })
            .catch(() => {
              console.error('Failed to load reCAPTCHA script');
            });
        }
    },
    watch: {
        captchaReady: function(data) {
            if (data) {
                clearInterval(this.checkInterval)
                this.render()
            }
        }
    },
    created () {
        this.$root.$on('grecaptcha-execute', this.execute)
    },
    mounted () {
        this.init()
    }
  }
  </script>
  